<script setup lang="ts">
import { Button } from '@/Components/ui/button'
import { Mail, Calendar } from 'lucide-vue-next'
import { trackEvent } from '@/composables/useAnalytics'

interface Props {
  tutorName: string
}

const props = defineProps<Props>()

const emit = defineEmits(['sendMessage', 'bookConsultation'])

function handleSendMessage() {
  trackEvent('contact', { tutor_name: props.tutorName, method: 'message' })
  emit('sendMessage')
}

function handleBookConsultation() {
  trackEvent('contact', { tutor_name: props.tutorName, method: 'consultation' })
  emit('bookConsultation')
}
</script>

<template>
  <section class="bg-white rounded-2xl shadow-sm p-6">
    <h3 class="text-lg font-semibold text-gray-900 mb-4">Contact {{ tutorName }}</h3>
    <div class="space-y-3">
      <Button
        class="w-full bg-blue-100 text-blue-700 font-medium py-3 rounded-xl hover:bg-blue-200 transition-colors flex items-center justify-center"
        variant="ghost"
        @click="handleSendMessage"
      >
        <Mail class="w-5 h-5 mr-2" />
        Send Message
      </Button>
      <Button
        class="w-full bg-purple-100 text-purple-700 font-medium py-3 rounded-xl hover:bg-purple-200 transition-colors flex items-center justify-center"
        variant="ghost"
        @click="handleBookConsultation"
      >
        <Calendar class="w-5 h-5 mr-2" />
        Book Consultation
      </Button>
    </div>
  </section>
</template>
